module.exports = __webpack_public_path__ + "img/bg_banner.394b722a.png";